import { render, staticRenderFns } from "./proxyForm.vue?vue&type=template&id=47fe3424&scoped=true"
import script from "./proxyForm.vue?vue&type=script&lang=js"
export * from "./proxyForm.vue?vue&type=script&lang=js"
import style0 from "./proxyForm.vue?vue&type=style&index=0&id=47fe3424&prod&scoped=true&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe3424",
  null
  
)

export default component.exports